<loading [visible]="loading() || saving()"></loading>

@if(!loading()){
<app-custom-modal maxWidth="7xl"
    [customTitle]="(id ? 'Editar' : 'Nuevo') + ' Producto' + (saveForm.get('id_by_company')?.value ? ' : ' + saveForm.get('id_by_company')?.value : '')"
    (closeFunction)="closeFormFunction()" (acceptFunction)="saveEntity()">

    <form [formGroup]="saveForm" class="space-y-3">

        @if(parentProduct){
        <div class="p-3 text-sm bg-purple-50 border border-purple-200 rounded-xl text-purple-900">
            Variación de <strong>{{ parentProduct.name }}</strong>@if(parentProduct.code){ ({{ parentProduct.code }})}.
            El nombre, familia, proveedor, unidad, impuestos y tipo se heredan del producto padre; aquí solo se editan precios, referencia y stock.
        </div>
        } @else if(hasVariations){
        <div class="p-3 text-sm bg-blue-50 border border-blue-200 rounded-xl text-blue-900">
            Producto variable: no se vende directamente, en ventas y tickets se elige una de sus variaciones.
            Los cambios en familia, proveedor, impuestos, etc. se aplican también a las variaciones.
        </div>
        }

        <section class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2">

                <div class="grid grid-cols-1 md:grid-cols-8 gap-3">
                    <custom-input [autofocus]="true" class="col-span-4" label="Nombre" type="text"
                        [formControlItem]="saveForm.get('name')"></custom-input>
                    @if(!restaurantView){
                    <custom-input class="col-span-2" label="Referencia " type="text"
                        [formControlItem]="saveForm.get('code')" [errorMessages]="{ codeTaken: 'Esta referencia ya existe' }"></custom-input>
                    }
                </div>



                <div class="grid grid-cols-1 md:grid-cols-12 gap-3">

                    @if(!restaurantView){
                    <div class="col-span-3">
                        <custom-select label="Proveedor" [formControlItem]="saveForm.controls['provider_id']"
                            [options]="dropdowns.providers" bindValue="id" bindLabel="name" [isMultiple]="false"
                            placeholder="Selecciona un proveedor" [createComponent]="providerFormComponent"
                            (itemCreated)="loadDropdowns()">
                        </custom-select>
                    </div>
                    }

                    <div class="col-span-3">
                        <custom-select label="Familia" [formControlItem]="saveForm.controls['category_id']"
                            [options]="dropdowns.categories" bindValue="id" bindLabel="name" [isMultiple]="false"
                            placeholder="Selecciona una familia" [createComponent]="categoryFormComponent"
                            (itemCreated)="loadDropdowns()">
                        </custom-select>
                    </div>
                    @if(!restaurantView){
                    <div class="col-span-2">
                        <custom-select label="Unidad de medida" [formControlItem]="saveForm.controls['measurement_id']"
                            [options]="dropdowns.measurements" bindValue="id" bindLabel="name" [isMultiple]="false"
                            placeholder="Selecciona una unidad">
                        </custom-select>
                    </div>
                    }
                    <custom-input label="Precio de compra" decimal [formControlItem]="saveForm.get('cost')"
                        class="col-span-2"></custom-input>
                    <div class="col-span-2">
                        <custom-select label="Impuestos" [formControlItem]="saveForm.controls['tax_type']"
                            [options]="dropdowns.taxes" bindValue="id" bindLabel="quotient" [isMultiple]="false"
                            placeholder="Selecciona un impuesto">
                        </custom-select>
                    </div>
                    <div class="col-span-3">
                        <custom-select label="Tipo de producto" [formControlItem]="saveForm.controls['product_type_id']"
                            [options]="dropdowns.productTypes" bindValue="id" bindLabel="name" [isMultiple]="false"
                            placeholder="Selecciona un tipo de producto" [createComponent]="productTypeFormComponent"
                            (itemCreated)="loadDropdowns()">
                        </custom-select>
                    </div>
                    @if(restaurantView && selectedProductTypeAllowsAllergens){
                    <div class="col-span-3">
                        <custom-select label="Alérgenos" [formControlItem]="saveForm.controls['allergens']"
                            [options]="allergenOptions" bindValue="value" bindLabel="label" [isMultiple]="true"
                            placeholder="Selecciona los alérgenos">
                        </custom-select>
                    </div>
                    }
                </div>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                    @if(!restaurantView && tariffItems.controls.length > 0){
                    <div class="md:col-span-3 p-3 bg-white rounded-2xl border border-black">
                        <h4
                            class="text-xs font-bold uppercase tracking-[0.2em] text-black mb-6 border-b-2 border-black pb-2">
                            Tarifas de Facturación
                            <button (click)="calculateAllPrices()" tabindex="-1"
                                class="cursor-pointer ml-2 px-3 py-1 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                                Calcular Precios
                            </button>
                        </h4>
                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2" formArrayName="more_prices">
                            @for (item of tariffItems.controls; track item; let i = $index) {
                            <div [formGroupName]="i" class="p-2 rounded-xl border transition-all duration-200"
                                [class.bg-yellow-50]="tariffOverrides[i]" [class.border-black]="true"
                                [class.border-dashed]="!tariffOverrides[i]">

                                <div class="space-y-3">
                                    <custom-input label="Porcentaje" decimal
                                        [formControlItem]="item.get('quotient')"
                                        [quotientToPercentage]="item.get('quotient')"></custom-input>

                                    <div>
                                        <label class="text-[10px] font-bold text-black uppercase block mb-1">
                                            Precio Tarifa € @if(tariffOverrides[i]){ (Manual) }
                                        </label>
                                        <input type="text" inputmode="decimal" decimalInput padDecimals formControlName="price" (focus)="markAsManual('price', i)"
                                            (input)="markAsManual('price', i)"
                                            class="w-full px-3 py-2 text-sm font-black border border-black rounded-lg bg-white focus:outline-none">
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>

            @if(!restaurantView){
            <div class="flex flex-col gap-2">
                <div class="flex-1 p-2 mt-2 rounded-xl border border-black bg-neutral-50">
                    <label class="block mb-2 text-sm font-bold text-black uppercase tracking-wider">
                        Medidas
                    </label>
                    <div class="grid grid-cols-1 gap-2">
                        <custom-input label="Alto (h)" decimal
                            [formControlItem]="saveForm.get('special_measures.h')"></custom-input>
                        <custom-input label="Ancho (w)" decimal
                            [formControlItem]="saveForm.get('special_measures.w')"></custom-input>
                        <custom-input label="Profundidad (t)" decimal
                            [formControlItem]="saveForm.get('special_measures.t')"></custom-input>
                    </div>
                </div>

                <div
                    class="md:col-span-1 p-3 bg-white rounded-2xl border border-black flex flex-col items-center gap-3">
                    <h2 class="block text-xl font-bold text-black tracking-wider">Precio medio</h2>
                    <h2 class="block text-xl text-black tracking-wider"
                        [centToEurDisplay]="saveForm.get('medium_price')?.value"></h2>
                </div>
            </div>
            }


        </section>

        <section class="grid grid-cols-1 md:grid-cols-4 flex-col md:flex-row gap-2">

            <div class="grid grid-cols-1 gap-2">


                @if(coeTaxDefault){
                <div class="p-3 bg-white rounded-2xl border border-black">
                    <h4 class="text-xs font-black uppercase tracking-widest text-black mb-4">
                        Configuración de Precio Ticket
                    </h4>
                    <div class="grid grid-cols-1 gap-3 items-end">
                        <div>
                            <label class="block mb-2 text-sm font-bold text-black">
                                Precio Final (IVA incluido)
                                @if(manualOverrides['price_ticket']){
                                <span class="text-black bg-yellow-300 px-2 py-0.5 rounded text-[10px] ml-2">
                                    MANUAL
                                </span>
                                }
                            </label>
                            <div class="relative">
                                <input type="text" inputmode="decimal" decimalInput padDecimals formControlName="price_ticket" (focus)="markAsManual('price_ticket')"
                                    (input)="markAsManual('price_ticket')"
                                    class="w-full pl-4 pr-10 py-3 text-lg font-black border border-black rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-black/5"
                                    [class.bg-yellow-50]="manualOverrides['price_ticket']">
                                <span class="absolute right-4 top-3.5 text-black font-bold">€</span>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>



        </section>
        @if(!restaurantView){
        <div class="grid grid-cols-1 md:grid-cols-4 gap-3">
            <div class="md:col-span-3">
                <label class="block mb-2 text-sm font-bold text-black uppercase tracking-wider">Descripción</label>
                <textarea tabindex="-1"
                    class="flex-1 w-full px-4 py-3 border border-black rounded-xl bg-white focus:outline-none focus:ring-2 focus:ring-black/5 min-h-5"
                    formControlName="description" placeholder="Detalles técnicos del producto..."></textarea>
            </div>
            <div class="md:col-span-1 p-3 bg-white rounded-2xl border border-black flex flex-col items-center gap-3">
                <h2 class="block text-xl font-bold text-black tracking-wider">Stock actual</h2>
                @if(hasVariations){
                <span class="text-sm text-neutral-600 text-center">Ver stock de cada variación</span>
                } @else {
                <h2 class="block text-xl text-black tracking-wider">{{ saveForm.get('stock')?.value }}</h2>
                }
            </div>
        </div>
        }

        @if(id && !parentProduct){
        <app-product-variations [productId]="id" [productTypeId]="savedProductTypeId"
            (changed)="onVariationsChanged()"></app-product-variations>
        }
    </form>
</app-custom-modal>
}